import { createContext, useContext } from "react";

interface ClosableModalContextType {
  onRequestClose: () => void;
}

export const ClosableModalContext = createContext<ClosableModalContextType | null>(null);

export function useClosableModal() {
  return useContext(ClosableModalContext);
}
